import React from 'react';

import {
  Action,
  Actions,
  FileDownloadIcon,
  FileUploadIcon,
  DescriptionIcon,
  ActionBar,
} from '@gogame/components';
import { FullScreenToggler } from '@gogame/data-grid';
import { SearchField, useScreenTitle } from '@gogame/screens';
import { useExportTemplate, useStatusTemplates } from 'Templates';
import {
  TEMPLATE_NEW_SPEND_ADJUSTMENT,
  TEMPLATE_UPLOAD_BY_CAMPAIGNS,
} from '../../constants';

export default function IntegrationsToolbar({
  onExport,
  onImportSpendAdjustments,
  onImportSpendAdjustmentsByCampaigns,
  onCreate,
}) {
  const [screenTitle] = useScreenTitle();

  const [downloadTemplate] = useExportTemplate({
    name: TEMPLATE_NEW_SPEND_ADJUSTMENT,
  });
  const [downloadTemplateByCampaigns] = useExportTemplate({
    name: TEMPLATE_UPLOAD_BY_CAMPAIGNS,
  });

  const handleDownloadTemplate = async () => {
    await downloadTemplate();
  };
  const handleDownloadTemplateByCampaigns = async () => {
    await downloadTemplateByCampaigns();
  };

  const templateNewUpdated = useStatusTemplates({
    name: TEMPLATE_NEW_SPEND_ADJUSTMENT,
  });

  const templateByCampaignsUpdated = useStatusTemplates({
    name: TEMPLATE_UPLOAD_BY_CAMPAIGNS,
  });

  return (
    <ActionBar
      title={screenTitle}
      search={<SearchField tooltip={'Search by id'} />}
      secondaryActions={
        <Actions>
          <Action
            icon={<FileDownloadIcon />}
            label={'Export Spend Adjustments'}
            onClick={onExport}
          />
          <Action
            icon={<FileUploadIcon />}
            tooltip={'Import Spend Adjustments'}
          >
            <Action
              label={'Import Spend Adjustments'}
              onClick={onImportSpendAdjustments}
            />
            <Action
              label={'Import Spend Adjustments by Campaigns'}
              onClick={onImportSpendAdjustmentsByCampaigns}
            />
          </Action>
          <Action icon={<DescriptionIcon />} tooltip={'Download Template'}>
            <Action
              label={'Download template'}
              onClick={handleDownloadTemplate}
              badge={templateNewUpdated ? 'Updated' : null}
            />
            <Action
              label={'Download template by Campaigns'}
              onClick={handleDownloadTemplateByCampaigns}
              badge={templateByCampaignsUpdated ? 'Updated' : null}
            />
          </Action>
          <Action component={FullScreenToggler} />
        </Actions>
      }
      primaryActions={
        <Actions>
          <Action
            border={true}
            button={true}
            add={true}
            iconContent={true}
            tooltip={'Add Spend Adjustment'}
            variant={'outlined'}
            onClick={onCreate}
          />
        </Actions>
      }
    />
  );
}
